var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import config from '../services/config';
export var cdr = function cdr(siteApi, centralApi, getToken) {
  return {
    get: function get(id) {
      return siteApi.get("/cdr/".concat(id));
    },
    index: function index(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.get('/cdr', {
        params: params
      });
    },
    transcription: function transcription(id) {
      return centralApi.get("/cdr/".concat(id, "/transcription"));
    },
    recordingUrl: function recordingUrl(_recordingUrl) {
      if (_recordingUrl == null) {
        return null;
      }
      if (_recordingUrl.indexOf('http') == -1) {
        _recordingUrl = config.api.url + _recordingUrl;
      }
      var separator = _recordingUrl.indexOf('?') > -1 ? '&' : '?';
      return _recordingUrl + separator + 'token=' + getToken().accessToken;
    },
    excelIndexUrl: function excelIndexUrl(params) {
      return siteApi.buildUrl('/cdr.xls', __assign(__assign({}, params), {
        token: getToken().accessToken
      }));
    },
    pdfUrl: function pdfUrl(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.buildUrl('/cdr.pdf', __assign(__assign({}, params), {
        token: getToken().accessToken
      }));
    }
  };
};